import { css } from 'styled-components'

export const coverBackground = color => css`
  box-shadow: 50vw 0 0 0 ${color}, -50vw 0 0 0 ${color};
`
